import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const MaintainanceContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 0;
    background: #140f4b 0% 0% no-repeat padding-box;
    opacity: 1;
    height: 100vh;

    ${media.mobileDevice`
        flex-direction: column;
        justify-content:center;
        align-items:center;
        padding: 0;
        margin-top: ${({ marginTop }) => (marginTop ? marginTop : '-8rem')};
        `}
`;
export const Header = styled.div`
    font-size: 30px;
    color: #ffffff;
    font-family: 'AvenirNextWorld Demi';
    opacity: 1;
    width: 233px;
    height: 65px;
    text-align: left;
    ${media.mobileDevice`
        font-size:35px;
        height:65px;
    `}
`;
export const Reason = styled.div`
    width: 398px;
    height: max-content;
    overflow: scroll;
    font-size: 16px;
    line-height: 24px;
    color: #ffad00;
    font-family: 'AvenirNextWorld Demi';
    opacity: 1;
    text-align: left;

    ${media.mobileDevice`
        width: 233px;
        height: max-content;
        font-size: 15px;
    `}
    & a {
        color: #ffad00;
    }
`;
export const Text = styled.div`
    width: 400px;
    height: 90px;
    max-height: 90px;
    overflow-y: scroll;
    text-align: left;
    font: normal normal normal 16px/24px Avenir Next World;
    font-family: 'AvenirNextWorld Thin';
    color: #ededed;
    letter-spacing: -0.38px;
    opacity: 1;

    &::-webkit-scrollbar-track {
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
    }

    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #ededed;
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        height: 5px;
    }

    span {
        text-decoration: underline #ededed;
        text-decoration-thickness: 1px;
    }

    ${media.mobileDevice`
        width: 233px;
        height: 157px;
        max-height:157px;
        &::-webkit-scrollbar-track {
            border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        }
        &::-webkit-scrollbar {
            display: block;
            width: 5px;
        }
    
        &::-webkit-scrollbar-thumb {
            background-color: #ededed;
            border-radius: ${({ theme }) => theme.scrollOption.border_radius};
            height: 5px;
        }
    `}
    & a {
        color: #ededed;
    }
`;
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
`;
export const ButtonText = styled.div`
    display: flex;
    align-items: center;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    color: #ffff;
    cursor: pointer;
    margin-right: 10px;
    white-space: nowrap;
    ${media.mobileDevice`
        
    `}
`;
export const ImageContainer = styled.div`
    width: ${({ width }) => (width ? width : '200px')};
    height: ${({ height }) => (height ? height : '200px')};
    ${media.mediumDevice`
        width:${({ mdWidth }) => (mdWidth ? mdWidth : '40%')};
    `}
    ${media.mobileDevice`
        width:${({ mbWidth }) => (mbWidth ? mbWidth : '80px')};
        height:${({ mbHeight }) => (mbHeight ? mbHeight : '80px')};
    `}
`;
export const Image = styled.img`
    width: ${({ width }) => (width ? width : '200px')};
    height: ${({ height }) => (height ? height : '200px')};
    ${media.mobileDevice`
        width:${({ mbWidth }) => (mbWidth ? mbWidth : '80px')};
        height:${({ mbHeight }) => (mbHeight ? mbHeight : '80px')};
    `}
`;
